import { render, staticRenderFns } from "./AnalyticsSetting.vue?vue&type=template&id=5b10b604&scoped=true&"
import script from "./AnalyticsSetting.vue?vue&type=script&lang=js&"
export * from "./AnalyticsSetting.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsSetting.vue?vue&type=style&index=0&id=5b10b604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10b604",
  null
  
)

export default component.exports